import React from 'react';
import { useTranslation } from 'react-i18next';
import enTexts from './ProfilEn.json';
import deTexts from './ProfilDe.json';
import styles from './Profil.module.css';
//import avatar from '../../assets/images/avatar.png';

function Profil() {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    // Wähle die passenden Übersetzungen basierend auf der Sprache aus:
    const texts = currentLang.startsWith('de') ? deTexts : enTexts;

    return (
        <div className={styles.container}>
            {/* Hero-Bereich */}
            <section className={styles.hero}>
                <div className={styles.overlay}>
                    <h1>{texts.heroTitle}</h1>
                    <p>{texts.heroSubtitle}</p>
                </div>
            </section>

            {/* Profil-Info */}
            <section className={styles.aboutContent}>
                {
                    // <div className={styles.profileImage}>
                    //     <img src={avatar} alt="Profilbild von Lukas"/>
                    // </div>
                }

                <div className={styles.bio}>
                    <h2>{texts.aboutTitle}</h2>
                    <p>{texts.aboutText}</p>
                </div>
            </section>

            {/* Skills / Fähigkeiten */}
            <section className={styles.skills}>
                <h2>{texts.skillsTitle}</h2>
                <div className={styles.skillList}>
                    <div className={styles.skillItem}>C/C++</div>
                    <div className={styles.skillItem}>Arduino</div>
                    <div className={styles.skillItem}>Fusion 360</div>
                    <div className={styles.skillItem}>KiCad</div>
                    <div className={styles.skillItem}>Java</div>
                    <div className={styles.skillItem}>VHDL</div>
                    <div className={styles.skillItem}>JavaScript</div>
                    <div className={styles.skillItem}>MATLAB/Simulink</div>
                </div>
            </section>

        </div>
    );
}

export default Profil;
